import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";

// Register and Login Screen
import Login from "./views/Login";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import Shell from "./views/shell";
import Cookies from "js-cookie";

const Routes = (props) => {
  const [user, setUser] = useState({});
  useEffect(() => {
    let user = JSON.parse(sessionStorage.getItem("user"));
    setUser(user);
  }, []);

  return (
    <div className="App">
      <Switch>
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={ResetPassword} />
        {/* <Route path="/">{isLoggedIn ? <Shell /> : <Login />}</Route> */}
        <Route path="/">{user !== null ? <Shell /> : <Login />}</Route>
      </Switch>
    </div>
  );
};

export default Routes;
